<template>
    <div>
        <ul>
            <li v-for="(item, index) in chargeModeList" :key="index" @click="onClick(index)">{{item.name}}</li>
        </ul>

        <Modal v-model="modal" :title="chargeModeList[activeTabIndex].name" width="40">
            <div class="content">
                <div>
                    <strong>租赁类型：</strong>{{chargeModeList[activeTabIndex].type}}
                </div>
                <div>
                    <strong>租赁价格：</strong>{{chargeModeList[activeTabIndex].price}}
                </div>
                <div>
                    <strong>适用客户：</strong>{{chargeModeList[activeTabIndex].customer}}
                </div>
                <div>
                    <strong>使用场景：</strong>{{chargeModeList[activeTabIndex].senario}}
                </div>

            </div>

            <template #footer>
                <Button type="warning" @click="modal = false">关闭</Button>
            </template>
        </Modal>
    </div>
</template>

<script>

export default {

    data() {
        return {
            modal:false,
            chargeModeList: [{
                name: '普托邦-会员拆借',
                type: '不约定期限',
                price: '会员持有限额内免租费，超额租赁按会员价按日计租。',
                customer: '有标准托盘需求的客户；有传统自购习惯的客户，管理精细有降本增效需求的客户；自购和租赁结合的客户',
                senario: '业务波峰期厂区、仓库等场景的静态租赁，一次性带板运输，自有托盘闲置期盘活'
            }, {
                name: '普惠托-约定租期',
                type: '约定期限',
                price: '按约定期限对应的价格档位计租，提前归还按阶梯价档位补差价，超期租费价格不变/按阶梯价格计租',
                customer: '分拨配送中心/大型零售DC 、物流企业 、快消/零售批发企业、业务周期可预计的固定租期客户、其他有托盘使用需求的的客户',
                senario: '长短期厂区、仓库等场景的静态租赁，交换模式/流转模式/异地归还模式的带板运输'
            }, {
                name: '随心托-随借随还',
                type: '不约定期限',
                price: '价格不固定，随借随还，按对应阶梯价格计租',
                customer: '分拨配送中心/大型零售DC 、物流企业 、快消/零售批发企业、租期无法计划的带板运输客户、其他有托盘使用需求的的客户',
                senario: '业务波峰期厂区、仓库等场景的静态租赁，交换模式/流转模式/异地归还模式的带板运输'
            }, {
                name: '快易托-按次租赁',
                type: '固定期限',
                price: '约定期限按打包价一次性收取租费，超期以固定日租费单价按日计租',
                customer: '所有需要异地单程带板运输且异地归还无过户的客户',
                senario: '专注于异地单程带板运输，帮助客户降低成本，可自选收发站点'
            }, {
                name: '定易托-固定租期',
                type: '固定期限',
                price: '约定最短租赁期限及对应租费价格，超期租费价格不变/按阶梯价格计租',
                customer: '分拨配送中心/大型零售DC 、物流企业 、快消/零售批发企业、业务周期可预计的固定租期客户、其他有托盘使用需求的的客户',
                senario: '长短期厂区、仓库等场景的静态租赁，交换模式/异地归还模式的带板运输'
            }, {
                name: '顺风托-按次特惠',
                type: '固定期限',
                price: '约定期限按特惠打包价一次性收取租费，超期以固定日租费单价按日计租',
                customer: '所有需要异地单程带板运输客户',
                senario: '适用于异地单程带板运输，特价款产品，收发站点城市不可选'
            }],
            activeTabIndex: 0,
        }
    },
    methods: {
        onClick(index) {

            this.activeTabIndex = index;
            this.modal =  true

        }
    }
}
</script>

<style lang="less" scoped>
ul {
    height: 436px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    li {
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        &:hover {
            cursor: pointer;
            color: #ff8800;
        }
    }
}
.content {
    // height: 150px;
    margin-left: 30px;
    font-size: 16px;
   >div{
       margin-top:10px;
   }
}
</style>